import {Injector} from '@angular/core';

export class InjectorProvider {
  static injector: Injector;
}
